const InfoAlert = (props) => {
    const isWarning = props.type === 'warning';

    return (
        <div className='my-3 text-start w-100'>
            <div
                className={`d-flex align-items-start w-100 px-3 py-2 rounded mt-3 font-b2 ${
                    isWarning ? 'bg-error-100 border border-danger' : 'bg-secondary-100'
                }`}
                role='alert'>
                <i
                    className={`${
                        isWarning ? 'sf-warning-filled text-error-700' : 'sf-info-filled text-secondary-700'
                    } me-2 flex-shrink-0`}
                    style={{ marginTop: '2px' }}
                />
                <span className='text-black font-b2 text-break' style={{ whiteSpace: 'pre-line' }}>
                    {props.title}
                </span>
            </div>
        </div>
    );
};

export default InfoAlert;
